<template>
    <div class="card-content">
        
        <kurama-loader
            v-if="load"
            msj="Cargando información"
        />

        <section class="" >
            <!-- <h4>Vuesax</h4> -->
            <px-table 
                :dataRows="dataRows" 
                :dataColumns="dataColumns" 
                :selected="selected"
                :checkAllRows="true"
                :expand="true"
                :maxNumber="10"
                @table-sort="handleSortTable"
                @select-all="handleSelectAllTable"
            >
            <template v-slot:cell="{value,type,property}">
                <template v-if="type == 'status'">
                    <px-badge 
                        :dataConfiguration="badgeConfiguration" 
                        :value="value.idestatus"
                        :description="value.desc_estatus"
                    >
                    </px-badge>
                </template>
                <template v-else-if="type == 'actions'">
                    <div class="btn-group dropstart">
                        <button
                            class="btn btn-circle dropdown-toggle"
                            style="border:none;"
                            type="button"
                            id="dropdown"
                            data-bs-toggle="dropdown" 
                            aria-expanded="false"
                        >
                        <font-awesome-icon icon="fa-solid fa-gear" class="text-gray-medium" />
                        </button>
                        <ul class="dropdown-menu">
                            <li><button class="dropdown-item" type="button">Opcion #1</button></li>
                            <li><button class="dropdown-item" type="button">Opcion #2</button></li>
                            <li><button class="dropdown-item" type="button">Opcion #3</button></li>
                            <li><button class="dropdown-item" type="button">Opcion #4</button></li>
                            <li><button class="dropdown-item" type="button">Opcion #5</button></li>
                        </ul>
                    </div>
                </template>
                <template v-else>{{value[property]}}</template>
            </template>
            <template v-slot:expand="{value}">
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                        <span>name: {{value.name}}</span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                        <span>username: {{value.username}}</span>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                        <span>email: {{value.email}}</span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                        <span>website: {{value.website}}</span>
                    </vs-col>
                </vs-row>
            </template>
            </px-table>
        </section>
        <vs-button class="btn-primary" @click="handleGetCatalogo"> Obtener Catalogos </vs-button>
        {{catalogos}}
    </div>
</template>
<script>
    import PxTable from '@/components/table/PxTable.vue'
    import PxBadge from '@/components/badge/PxBadge.vue'
    import mapHelper from '@/store/modules/common/map-helper'
    import CatalogoService from '@/services/catalogo/catalogo.service'

    export default {
        name:'PxTableEjemplo',
        components:{PxTable,PxBadge},
        data(){
            return{
                dataRows: 
                [
                    {
                    "id": 1,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"097",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 2,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"097",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },
                    {
                    "id": 3,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"097",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 4,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"097",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },
                    {
                    "id": 5,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"099",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 6,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"097",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 7,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"097",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 8,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"097",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },
                    {
                    "id": 9,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"105",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },
                    {
                    "id": 11,
                    "numero": "2023000521",
                    "dep": "21111110",
                    "ur": "01",
                    "uro": "001",
                    "f": "1",
                    "fun":"5",
                    "sf":"2",
                    "ssf":"1",
                    "sp":"B",
                    "pp":"101",
                    "oa":"01",
                    "ai":"H01",
                    "pest":"A001",
                    "nombre":"Modernización informática (eventual)",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },                                                                                                                                    
                ],
                dataColumns:
                [
                    {
                        columnName:"Numero",
                        columnProperty:"numero",
                        type:"text",
                        filter:true,
                        sort:true,
                        rowsFilter:[]
                    },
                    {
                        columnName:"Dep",
                        columnProperty:"dep",
                        filter:true,
                        type:"text",
                        sort:false,
                        rowsFilter:[]
                    },
                    // {
                    //     columnName:"Id",
                    //     columnProperty:"id",
                    //     filter:true,
                    //     type:"number",
                    //     sort:false,
                    //     rowsFilter:[]
                    // },
                    {
                        columnName:"UR",
                        columnProperty:"ur",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"URO",
                        columnProperty:"uro",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"F",
                        columnProperty:"f",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"Fun",
                        columnProperty:"fun",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"SF",
                        columnProperty:"sf",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"SSF",
                        columnProperty:"ssf",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"SP",
                        columnProperty:"sp",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"PP",
                        columnProperty:"pp",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"OA",
                        columnProperty:"oa",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"AI",
                        columnProperty:"ai",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"PEst",
                        columnProperty:"pest",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"Nombre",
                        columnProperty:"nombre",
                        type:"text",
                        filter:true,
                        sort:false,
                        rowsFilter:[]
                    },
                    {
                        columnName:"Estatus",
                        columnProperty:"desc_estatus",
                        type:"status",
                        filter:true,
                        sort:true,
                        rowsFilter:[]
                    },
                    // {
                    //     columnName:"Acciones",
                    //     columnProperty:"",
                    //     type:"actions",
                    //     filter:false,
                    //     sort:false,
                    //     rowsFilter:[]
                    // }
                ],
                selected:[],
                badgeConfiguration:[
                    {
                        value:1,
                        colorClass:"badge rounded-pill bg-sucess-sh text-white-sh"
                    },
                    {
                        value:2,
                        colorClass:"badge rounded-pill bg-danger-sh text-white-sh"
                    },
                    {
                        value:3,
                        colorClass:"badge rounded-pill bg-warning-sh text-gray-medium"
                    },
                ],
                columns: ['Name', 'Email', 'Estatus', 'Acciones'],
                load:false
            }
        },
        methods:{
            handleSortTable($event, columnProperty){
                this.dataRows = this.$vs.sortData($event ,this.dataRows , columnProperty)
            },
            handleSelectAllTable(){
                this.selected = this.$vs.checkAll(this.selected, this.dataRows)
            },
            // async ObtenerCoins(){
            //     let response = await CoinService.Obtener()
            //     console.log(response)
            //     if(response.success){
            //         this.coins = response.data
            //     }
            // },
            async handleGetCatalogo(){
                try{
                   this.load = true
                   this.$store.dispatch(mapHelper.mapmod.SIAHE_CATALOGO+mapHelper.mapfn.fetchCatalogos);
                }catch(error){
                    console.log(error.message)
                }finally{
                    this.load = false
                }
            }
        },
        computed:{
            coins() {
                // core/coin/getCoins
                return this.$store.getters[mapHelper.mapmod.SIAHE_COIN+mapHelper.mapfn.getCoin]
            },
            catalogos() {
                return this.$store.getters[mapHelper.mapmod.SIAHE_CATALOGO+mapHelper.mapfn.getCatalogos]
            }
        },
        async mounted(){
            //core/coin/fetchCoins
            // console.log(mapHelper.mapmod.SIAHE_COIN+mapHelper.mapfn.fetchCoins)
            // console.log(mapHelper.mapmod.SIAHE_COIN+mapHelper.mapfn.getCoin)

            // this.$store.dispatch(mapHelper.mapmod.SIAHE_COIN+mapHelper.mapfn.fetchCoins);


        }
}
</script>
